<template>
    <div class="container">
        <div class="row ">
            <div class="col d-flex justify-content-center">
                <img alt="Book and glasses" src="./../assets/Axum.png" class="img-fluid mt-5">
            </div>


        </div>
    </div>
</template>